import { render, staticRenderFns } from "./calculate-salary.vue?vue&type=template&id=5031361e&scoped=true"
import script from "./calculate-salary.vue?vue&type=script&lang=js"
export * from "./calculate-salary.vue?vue&type=script&lang=js"
import style0 from "./calculate-salary.vue?vue&type=style&index=0&id=5031361e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031361e",
  null
  
)

export default component.exports